import React from "react";
import { motion } from 'framer-motion';
import './Card.css';

export const Card = ({ className, children }) => (
  <motion.div
    className={`card ${className}`}
    initial={{ opacity: 0, y: 50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
  >
    {children}
  </motion.div>
);

export const CardContent = ({ children }) => {
  return <div className="card-content">{children}</div>;
};

export default Card;